import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authAxios } from "setups/axios";

export const fetchOfficersList = createAsyncThunk(
  "officers/fetchOfficersList",
  async (SAP_ID) => {
    const res = await authAxios()({
      url: `/api/v1/AM/SO/${SAP_ID}`,
      method: "GET",
    });

    console.log({ YU: res.data });

    return res?.data?.data;
  }
);
export const getCoverageArea = createAsyncThunk(
  "officers/getCoverageArea",
  async (SAP_ID) => {
    const res = await authAxios()({
      url: `/api/v1/getOfficers/AREA`,
      method: "GET",
    });

    console.log({ YU: res });

    return res?.data?.data;
  }
);

export const officersSlice = createSlice({
  name: "officers",
  initialState: {
    loading: false,
    officers: [],
    officerLoading: false,
    officersList: [],
    officerError: null,
  },
  extraReducers: {
    [fetchOfficersList.fulfilled]: (state, action) => {
      state.loading = false;
      state.officers = action.payload?.officers;
    },
    [fetchOfficersList.rejected]: (state, action) => {
      state.loading = false;
      state.officers = [];
    },
    [fetchOfficersList.pending]: (state, action) => {
      state.loading = true;
      state.officers = [];
    },
    [getCoverageArea.fulfilled]: (state, action) => {
      state.officerLoading = true;
      state.officersList = action.payload?.officers;
    },
    [getCoverageArea.rejected]: (state, action) => {
      state.officerLoading = false;
      state.officersList = [];
    },
    [getCoverageArea.pending]: (state, action) => {
      state.officerError = action.payload;
      state.officersList = [];
    },
  },
});

// export const { getOfficer, setOfficer } = officersSlice.actions;

export default officersSlice.reducer;
